import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _BitLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M15.623 3.5 17.5 5.762V8.5h-11V5.762L8.377 3.5zM17.77 8.7l.134.103 1.852 1.42c.438.262.744.71.744 1.235v4.565c0 2.557-2.465 4.477-5.3 4.477h-.728a2.5 2.5 0 0 1-1.117-.264l-1.32-.66-.754.504a2.5 2.5 0 0 1-1.386.42H8.8c-2.835 0-5.3-1.92-5.3-4.477v-4.565c0-.525.305-.973.743-1.235l1.853-1.42.134-.103z" }),
            React.createElement("path", { stroke: "currentColor", d: "M8.5 13s-.08 3.672 0 4.5c.058.603 1.723 2.654 2 3M16 13s.08 3.672 0 4.5c-.058.603-1.818 2.654-2.095 3" }),
            React.createElement("circle", { cx: 12, cy: 13.5, r: 0.5, fill: "currentColor" }),
            React.createElement("circle", { cx: 18.5, cy: 13.5, r: 0.5, fill: "currentColor" }),
            React.createElement("circle", { cx: 5.5, cy: 13.5, r: 0.5, fill: "currentColor" }),
            React.createElement("circle", { cx: 12, cy: 16.5, r: 0.5, fill: "currentColor" }),
            React.createElement("circle", { cx: 18.5, cy: 16.5, r: 0.5, fill: "currentColor" }),
            React.createElement("circle", { cx: 5.5, cy: 16.5, r: 0.5, fill: "currentColor" })));
}
const BitLight = forwardRef(_BitLight);
export { BitLight };
